<template>
  <Navbar>
    <template v-slot:navbarTitle>仕入管理</template>
  </Navbar>

  <main id="main" class="container-fluid pt-3">
    <div class="d-flex gap-2 mb-3">
      <h5 class="m-0 p-0"><i class="bi bi-folder me-1"></i>不良原因一覧</h5>
      <div class="ms-auto">
        <button
          type="button"
          v-on:click.prevent="showDefectiveItemCauseForm()"
          class="btn btn-primary"
        >
          <span class="d-block d-sm-none"><i class="bi bi-plus-lg"></i></span>
          <span class="d-none d-sm-block"
            ><i class="bi bi-plus-lg me-1"></i>不良原因を登録する</span
          >
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mb-2">
      <Pagination :prev="prev" :next="next" @move-page="movePage" />
    </div>

    <!-- causes -->
    <div v-if="causes && causes.length > 0">
      <data-table :headers="headers" :items="causes">
        <template #is_active="{ item }">
          <active-status :is_active="item.is_active" />
        </template>
        <template #actions="{ item }">
          <a
            href="#"
            v-on:click.prevent="showDefectiveItemCauseForm(item)"
            class="text-success text-decoration-none"
            >編集</a
          >｜<a
            v-on:click.prevent="removeData(item)"
            href="#"
            class="text-danger text-decoration-none"
            >削除</a
          >
        </template>
      </data-table>
    </div>
    <p v-else class="mt-3">該当するデータはありません。</p>
    <DeleteDialog ref="confirmDataDelete" @confirm-true="confirmDataDelete" />

    <DefectiveItemCauseForm ref="defectiveItemCauseForm" />
  </main>
</template>

<script>
import store from '../store'
import Navbar from '@/components/Navbar.vue'
import Pagination from '@/components/AppNoCountPagination.vue'
import DeleteDialog from '@/components/AppDeleteDialog.vue'
import DataTable from '@/components/common/DataTable.vue'
import ActiveStatus from '@/components/TheActiveStatus.vue'
import DefectiveItemCauseForm from '../components/DefectiveItemCauseForm.vue'

export default {
  name: 'ManagePurchaseDefectiveItemCauseList',
  components: {
    Navbar,
    Pagination,
    DeleteDialog,
    DataTable,
    ActiveStatus,
    DefectiveItemCauseForm,
  },

  data() {
    return {
      currentId: null,
      query: {},
      headers: [
        {
          key: 'cause',
          label: '原因',
          class: 'col-5',
          format: 'string',
        },
        {
          key: 'is_active',
          label: '有効',
          class: 'col-1',
          format: 'status',
        },
        {
          key: 'created_at',
          label: '作成日時',
          class: 'col-2',
          format: 'datetime',
        },
        {
          key: 'updated_at',
          label: '更新日時',
          class: 'col-2',
          format: 'datetime',
        },
        {
          key: 'actions',
          label: '',
          class: 'col-2',
          format: 'actions',
        },
      ],
    }
  },
  computed: {
    causes() {
      return store.getters['manage_purchase_defective_item_cause/results']
    },
    prev() {
      return store.getters['manage_purchase_defective_item_cause/prev']
    },
    next() {
      return store.getters['manage_purchase_defective_item_cause/next']
    },
  },

  async created() {
    await this.getData()
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  methods: {
    getData(query = {}) {
      return store.dispatch(
        'manage_purchase_defective_item_cause/fetchAll',
        query
      )
    },
    deleteData(id) {
      return store.dispatch(
        'manage_purchase_defective_item_cause/deleteData',
        id
      )
    },
    movePage(page) {
      this.getData(Object.assign(this.query, { page: page }))
    },
    showDefectiveItemCauseForm(formData) {
      this.$refs.defectiveItemCauseForm.show(formData)
    },
    removeData(object) {
      this.currentId = object.id
      this.$refs.confirmDataDelete.showDialog(
        '不良原因データ',
        object.cause,
        [],
        ['不良品情報']
      )
    },
    async confirmDataDelete() {
      try {
        await this.deleteData(this.currentId)
      } catch (e) {
        let message = '削除できませんでした。'
        if (e.response.status === 409) {
          message = 'この不良原因は使用しています。'
        }
        this.$store.dispatch('alert/setErrorMessage', {
          message: message,
        })
      }
      this.currentId = null
    },
  },
}
</script>
